import ApplicationForm from "@/components/ApplicationForm";
import { RevealLines } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { PAGE_META } from "@/data/content";
import usePageMeta from "@/hooks/usePageMeta";

export default function Apply() {
  const { t, lang } = useLanguage();
  usePageMeta({ ...PAGE_META[lang].apply, lang });
  const p = t.apply;
  return (
    <div className="pt-32 pb-28 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-6">
          <span className="text-y5-yellow text-sm uppercase tracking-[0.3em]">{p.kicker}</span>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl tracking-tight uppercase mt-4 mb-8 leading-[0.9]">
            <RevealLines lines={p.title} />
          </h1>
          <p className="text-y5-muted text-lg leading-relaxed mb-10 max-w-md">{p.text}</p>
        </div>
        <div className="lg:col-span-6">
          <div className="bg-y5-surface border border-y5-line p-8">
            <ApplicationForm />
          </div>
        </div>
      </div>
    </div>
  );
}
